// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ArrowLeft from "@adl/XDL/Icons/ArrowLeft";
import ArrowRight from "@adl/XDL/Icons/ArrowRight";
import { xBaseTheme } from "@adl/XDL/types";
import { mergeWithCss } from "@adl/XDL/Utilities";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        selectProps: {
            labelProps: {
                size: 15,
                weight: "normal",
            },
        },
        navIconsSrc: {
            firstPage: "ChevronsLeft",
            previousPage: ArrowLeft,
            nextPage: ArrowRight,
            lastPage: "ChevronsRight",
        },
        cssOverrides: {
            ...mergeWithCss(PaginationPresentationPropsDefault?.cssOverrides, {
                ellipsis: css`
                    margin: 0 10px;
                `,
            } as PaginationPresentationProps["cssOverrides"]),
        },
    },
} as xBaseTheme["pagination"];
